import { Box, Button, FormHelperText, IconButton, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import CancelIcon from '@mui/icons-material/Cancel';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useFileUpload } from 'shared/hooks/use-file-upload';

type QuoteFormFileUploadFieldProps = {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  accept: string;
  disabled?: boolean;
  isMultiple?: boolean;
  rules?: Object;
  error?: boolean;
  helperText?: string;
};

export function QuoteFormFileUploadField({
  name,
  accept,
  disabled = false,
  isMultiple,
  rules,
  error,
  helperText,
}: QuoteFormFileUploadFieldProps) {
  const { handleRemoveFile, handleChange, files, handleDragOver, handleDrop, handleDragEnter, trigger, inputRef } =
    useFileUpload();
  const { setValue } = useFormContext();

  const { field, fieldState } = useController({
    name,
    rules,
  });

  useEffect(() => {
    field.onChange(files);
  }, [setValue, files, field]);

  const hasFiles = !!files?.length;

  return (
    <>
      <input
        id={name}
        ref={inputRef}
        hidden
        type={'file'}
        multiple={!!isMultiple}
        accept={accept}
        onChange={handleChange}
      />
      {(!hasFiles || isMultiple) && (
        <div onDragOver={handleDragOver} onDrop={handleDrop} onDragEnter={handleDragEnter}>
          <Button onClick={trigger} startIcon={<FileUploadIcon />} disabled={disabled}>
            {`Select File${isMultiple ? '(s)' : ''}`}
          </Button>
          {fieldState.error && <FormHelperText error={true}>{fieldState.error?.message}</FormHelperText>}
        </div>
      )}
      {!!files && hasFiles && (
        <>
          {files.map((file, index) => (
            <Box display='flex' alignItems='center' key={`${index}-${file.name}`}>
              <Box>
                <Typography>{file.name}</Typography>
              </Box>
              <Box sx={{ paddingLeft: 1 }}>
                <IconButton title='Remove file' onClick={() => handleRemoveFile(file)}>
                  <CancelIcon />
                </IconButton>
              </Box>
            </Box>
          ))}
        </>
      )}
    </>
  );
}
